import { Permission, useIsUserWithPermission } from '@customer/permissions';
import { PropsWithChildren, ReactElement } from 'react';

interface ProtectedElementProps extends PropsWithChildren {
  permission: Permission;
  children: ReactElement | null;
}

export const ProtectedElement = ({
  permission,
  children,
}: ProtectedElementProps): ProtectedElementProps['children'] => {
  const accessAllowed = useIsUserWithPermission(permission);

  return accessAllowed ? children : null;
};
